import React from 'react'
import { Button } from 'hhsoig-design-system-core'

export const EmploymentWarning = () => {
  return (
    <div>
      <h2>You may not be a protected whistleblower</h2>
      <p>
        Based on your answer to the previous question, you may not be protected
        by HHS-OIG.
      </p>
      <a
        href="https://oig.hhs.gov/fraud/report-fraud/eligibility.asp"
        target="_blank"
        rel="noopener noreferrer"
      >
        Read more about who qualifies for whistleblower protection
      </a>
      <p>
        <Button
          variation="primary"
          data-testid="return-to-hhs-tips"
          href="https://oig.hhs.gov/fraud/report-fraud/index.asp"
        >
          Return to HHS-OIG Hotline
        </Button>
      </p>
      <h4>If you wish to continue with your complaint</h4>
      <p>
        By selecting Acknowledge and continue, you acknowledge that you have
        read and understood that based on your selection, you may not be a
        protected whistleblower under HHS-OIG's jurisdiction.
      </p>
    </div>
  )
}
